import React,{useState,useEffect} from 'react';
import StateContext from '../../helpers/ContextState';
import  {PostAsync} from '../../helpers/Functions';
import  Store from '../../helpers/Store';
import  Grabador from './grabador';
import  { faUpload,faFilePdf,faFile } from "@fortawesome/free-solid-svg-icons";
import  { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  imgDefault from '../../assets/images/design/avatar.png';
// import  queryString from 'query-string';
// const   queryStringParams = queryString.parse(window.location.search);
const   HtmlToReactParser = require('html-to-react').Parser;
let     htmlToReactParser = new HtmlToReactParser();

const limitUpload = 100*1000000;//100MB
let   audio       = false;

const App =(props)=>{
  const context             =   React.useContext(StateContext);
  const [data, setData]     = useState([]);
  const [inputs, setInputs] = useState({});
  const [blockTextarea, setBlockTextarea] = useState(false);
  const [verMas, setVerMas]       = useState({});
  const [mensajeArchivoAdjunto, setMensajeArchivoAdjunto]     = useState(false);
  //const [visible, setVisible]     = useState(false);

  useEffect(() => {
    getInit()
  },[props.id])

  useEffect(() => {
    getInit()
  },[props.reset])

  const getInit=()=>{
    if (props.id===undefined) { 
      return false;
    }
    let data              =   {}
        data.id           =   props.id
        data.usuario_id   =   window.location.href.split('/')[7]
        
        PostAsync("Comentarios","get",data,context).then((response)=>{
          setData(response.data)
        })
  }

  const onChange=(e)=>{
    e.preventDefault()
    let inputs_={...inputs}
        inputs_[e.target.name]=e.target.value
        setInputs(inputs_)
  }

  const onSubmit=(e)=>{
    e.preventDefault()

    let data            =   {...inputs}
        data.file       =   (Object.is(inputs.file,inputs.file))?JSON.stringify(inputs.file):""
        data.user       =   Store.get("user").token
        data.id         =   props.id
        data.receptor   =   window.location.href.split('/')[7]
        if (audio) {
          data.audio    =   JSON.stringify(audio)
        }
        // console.log("Please enter",data,context)
        if (data.mensaje!==undefined) {
          setBlockTextarea(true)
          PostAsync("Comentarios","set",data,context).then((response)=>{
            getInit()
            audio=false
            setBlockTextarea(false)
            setMensajeArchivoAdjunto(false)
            setInputs({})
          })
          //,{name:"callbackContinueSend",funct:callbackContinueSend})
        }else {
          setBlockTextarea(false)
          return context.setModalShow({
            show:true,
            message:<div className="text-center text-dark">El mensaje no debe ir vacío</div>
          })
        }

  }

  const upload=(event)=>{
    let file          =   event.target.files[0];
    let reader        =   new FileReader();

    reader.onload       =   function() {
      if (file.size<limitUpload) {
        let inputs_={...inputs}
            inputs_.file  =   { src:reader.result,
                                name:file.name,
                                lastModified:file.lastModified,
                                size:file.size,
                                type:file.type,
                              }

        let data            =   inputs_
            data.file       =   (Object.is(inputs_.file,inputs_.file))?inputs_.file:""
            data.user       =   Store.get("user").token
            data.id         =   props.id
            setInputs(data)
            if (inputs_.file!==undefined && inputs_.file.name!==undefined) {
              setMensajeArchivoAdjunto(inputs_.file.name)
            }
      }else {
        context.setModalShow({
          show:true,
          message:<div className="text-center text-danger">El Archivo supera el límite permitido de {limitUpload/1000000}MB</div>
        })
      }
    }
    reader.readAsDataURL(file);
  }

  const openFileTab=(url)=>{
    return window.open(url, '_blank').focus();
  }

  const openFile=(url)=>{

    context.setModalShow({
      show:true,
      message:<iframe id="inlineFrameExample"
                      title="Iframe ProgramandoWeb"
                      width="100%"
                      height="400"
                      src={url}>
                  </iframe>
    })
  }

  // const setAudio=(data)=>{
  //   audio = {
  //             src:data,
  //             type:"ogg",
  //           }
  // }

  const deleteAudio=(id_)=>{
    context.setModalShow({
      show:true,
      size:"",
      message:<div className="text-center">
                <div className="mb-3">¿Está seguro que desea eliminar este mensaje?</div>
                <div className="btn btn-primary2 mr-1 mb-2" onClick={()=>submitDeleteAudio(id_)}>Si</div>
                <div className="btn btn-gray" onClick={()=>context.setModalShow({show:false,size:"sm",message:""})}>No</div>
              </div>
    })
  }

  const submitDeleteAudio=(id_)=>{
    context.setModalShow({show:false,size:"sm",message:""})

    let data            =   {}
        data.user       =   Store.get("user").token
        data.id         =   id_
        //PostAsync("Comentarios","deleteAudio",data,context,{name:"callbackDeleteAudio",funct:callbackDeleteAudio})//Original
        PostAsync("Comentarios","deleteAudio",data,context).then((response)=>{
          audio=false
          getInit()
        })
  }

  const callbackDeleteAudio=()=>{
    getInit()
    audio=false
  }
  const enviar_audio=(base64data,tada)=>{
    let data            =   {}
        data.user       =   Store.get("user").token
        data.id         =   props.id
        data.audio      =   JSON.stringify({  
          src:base64data,
          name:"notadevoz",
          lastModified:"2020202020",
          size:1000,
          type:"ogg",
        })
        data.receptor   =   window.location.href.split('/')[7]
        PostAsync("Comentarios","setAudio",data,context).then((response)=>{
          getInit()
          audio=false
          setBlockTextarea(false)
          setMensajeArchivoAdjunto(false)
          setInputs({})
        })

  }

  const Reproductor=(props)=>{
    return <audio controls volume="0.5">  <source src={props.src} type="audio/ogg"/></audio>
  }

  // const onChangeEditOnline=(e,row)=>{
  //   let inputs_                 =   {};
  //       inputs_[e.target.name]  =   e.target.value
  //       inputs_.user            =   context.Store.get("user").token
  //       inputs_.id              =   row.mensaje_token
  //       PostAsync("Comentarios","setItemsOnline",inputs_,context,{name:"callbackEditOnline",funct:callbackEditOnline})
  // }

  // const callbackEditOnline=(dataR)=>{
  //   //console.log(dataR);
  // }

  const openText=(key)=>{
    let vermas_       = {...verMas}
        vermas_[key]  = (vermas_[key]===undefined || vermas_[key]===false)?true:false
        setVerMas(vermas_)
  }

  // const handleVisible=()=>{
  //   let data            =   {...inputs}
  //   let option          =   visible?false:true
  //       data.visible    =   option
  //       setInputs(data)
  //       setVisible(option)
  // }

  return  <><div className="Container-observaciones">
            <div className="container-input-observaciones">
              {!blockTextarea?<textarea
                  disabled={blockTextarea}
                  name="mensaje"
                  required="required"
                  placeholder="Comentarios..."
                  className="form-control"
                  onChange={onChange}></textarea>:<pre className="p-3">Enviando mensaje...</pre>}
            </div>
            <div className="opciones-Observaciones">
              <form onSubmit={onSubmit}>
                <div className="row justify-content-end">
                  <div className="col-1 text-end pr-2">
                    <Grabador enviar_audio={enviar_audio}/>
                  </div>
                  <div className="col-1 p-0 text-left">
                    <div className={!blockTextarea?"uploadFile position-relative":"uploadFile position-relative disabled"}>
                      <input type="file" accept="application/pdf" className="inputfile position-absolute" onChange={upload} />
                      <FontAwesomeIcon size="lg" icon={faUpload}/>
                    </div>
                  </div>
                  {mensajeArchivoAdjunto?<div className="col-6 p-0 text-left h6 text-rosa pt-2">
                    {mensajeArchivoAdjunto}
                  </div>:false}

                  <div className="col-1 text-right">
                    <button type="submit" className="btn btn-primary mr-2">
                      Enviar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {data.map((row,key)=>{
            let icon  = ""
            if (row.attachment) {
              switch (row.attachmentExtension) {
                case "pdf":
                  icon  = <div className="cursor-pointer" onClick={()=>openFileTab(row.attachment)} href={row.attachment}><FontAwesomeIcon size="lg" icon={faFilePdf}/></div>
                break;
                case "jpg":
                case "jpeg":
                case "gif":
                case "png":
                  icon  = <div className="cursor-pointer" onClick={()=>openFile(row.attachment)} href={row.attachment}>
                             <img className="col-2" src={row.attachment} alt="pgrw"/>
                          </div>
                break;
                default:
                  icon  = <div className="cursor-pointer" onClick={()=>openFile(row.attachment)} href={row.attachment}><FontAwesomeIcon size="lg" icon={faFile}/></div>
                break
              }
            }
            return <div className="row mt-3" key={key}>
                      <div className="col">
                        <div className="comentario-observacion">
                            <div className="img-comentario">
                                <img src={imgDefault} alt={row.nombres + " " + row.apellidos}/>
                            </div>
                            <div className={"texto-observacion"}>
                              <div className={verMas[key]===undefined || verMas[key]===false?"texto-observacion-close-":""}>
                                <b>{row.nombres} {row.apellidos}</b> <small className="label text-gray">{row.fecha}</small><br/>
                                {htmlToReactParser.parse(row.mensaje) }
                                {row.attachment!==undefined && row.attachment!=="0"?<div>
                                  {icon}
                                </div>:false}
                                {row.ogg!==undefined && row.ogg!=="0"?<Reproductor src={row.ogg}/>:false}
                              </div>
                              {row.mensaje.length>340?<div className="text-right">
                                <div className="btn btn-primary2 btn-sm" onClick={()=>openText(key)}>{verMas[key]===undefined || verMas[key]===false?"Abrir ":"Cerrar "} Texto completo</div>
                              </div>:false}
                              <div className="btn btn-primary2 btn-sm" onClick={()=>deleteAudio(row.mensaje_token)}>
                                Eliminar Mensaje
                              </div>
                            </div>
                            <div className="btn btn-primary2 btn-sm" >
                              <i className="icon-eliminar  cursor-pointer" onClick={()=>deleteAudio(row.mensaje_token)}></i>
                            </div>
                            {Store.get("user").tipo_usuario_id==='1' || Store.get("user").tipo_usuario_id==="2"&&false?<div className="acciones-comentarios" >
                              <i className="icon-eliminar  cursor-pointer" onClick={()=>deleteAudio(row.mensaje_token)}></i>
                            </div>:false}
                        </div>
                      </div>
                    </div>
          })}
        </>
}
export default App
